import React, { useState, useContext } from 'react';
import { Box, Alert, Button } from '@mui/material';
import AMRPredictionRow, { isHighPerformingModel } from './AMRPredictionRow';
import { IdentifiedSpeciesFiltersDispatchContext } from '../context/IdentifiedSpeciesFiltersContext';

const styles = {
    warningBox: {
        textAlign: 'left',
        backgroundColor: '#eee'
    },
    warningAlert: {
        borderRadius: 0
    },
    showButton: {
        backgroundColor: 'white',
        color: 'warning.dark',
        margin: '4px',
        '&:hover': {
            backgroundColor: '#f5f5f5',
        }
    },
    predictionsBox: {
        pl: 10,
        textAlign: 'center',
        backgroundColor: '#eee'
    }
}; 

function AMRPredictionsBlock(props) {
    const {
        isDiagnosticView,
        visibleAmrPredictions,
        qualityLimitations,
        amrPredictionsReference,
        resistanceGenes,
    } = props;

    const [amrPredictionsExpanded, setAmrPredictionsExpanded] = useState(!qualityLimitations.length);
    const { setShowRnDModels } = useContext(IdentifiedSpeciesFiltersDispatchContext);

    const onlyRnDModels = Object.values(amrPredictionsReference).every(
        prediction => !isHighPerformingModel(prediction.attributes)
    );

    const expandIfQualityLimitations = () => {
        // If there are no visible AMR predictions and only R&D models, show R&D models
        if (!Object.values(visibleAmrPredictions).length && onlyRnDModels) {
            setShowRnDModels(true);
        }
        setAmrPredictionsExpanded(true);
    };

    return (
        <>
            {qualityLimitations.length ? (
                <Box sx={styles.warningBox}>
                    <Alert 
                        variant="filled" 
                        severity="warning"
                        sx={styles.warningAlert}
                        action={
                            !amrPredictionsExpanded &&
                            <Button 
                                variant="contained"
                                size="small" 
                                sx={styles.showButton}
                                onClick={expandIfQualityLimitations}
                            >
                                SHOW ANYWAY
                            </Button>
                        }
                    >
                        <b>AMR predictions are {amrPredictionsExpanded ? 'flagged as high risk for error' : 'hidden'} due to quality limitations:</b> {qualityLimitations.map(val => val.toLowerCase()).join(', ')}
                    </Alert>
                </Box>
            ) : null}
            <Box sx={styles.predictionsBox}>
                {amrPredictionsExpanded && onlyRnDModels && (
                    <Alert
                        variant="filled"
                        severity="info"
                        sx={styles.warningAlert}
                    >
                        <b>No Qualified panel models for this organism.</b>
                        {!Object.values(visibleAmrPredictions).length ?
                        ' Change results display by toggling on R&D panel to see AMR profile.'
                        : ' Displaying only R&D panel models in AMR profile.'
                        }
                    </Alert>
                )}
                {amrPredictionsExpanded && visibleAmrPredictions.map(prediction => (
                    <AMRPredictionRow
                        key={prediction.id}
                        prediction={prediction}
                        isDiagnosticView={isDiagnosticView}
                        amrPredictions={amrPredictionsReference}
                        resistanceGenes={resistanceGenes}
                    />
                ))}
            </Box>
        </>
    );
}

export default AMRPredictionsBlock;
